import { render, staticRenderFns } from "./MapsAssignUsers.vue?vue&type=template&id=63c4b478&scoped=true"
import script from "./MapsAssignUsers.vue?vue&type=script&lang=js"
export * from "./MapsAssignUsers.vue?vue&type=script&lang=js"
import style0 from "./MapsAssignUsers.vue?vue&type=style&index=0&id=63c4b478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c4b478",
  null
  
)

export default component.exports